__turbopack_context__.v({
  "ctaLink": "HeroSection-module-scss-module__R9_E1a__ctaLink",
  "driftOne": "HeroSection-module-scss-module__R9_E1a__driftOne",
  "driftTwo": "HeroSection-module-scss-module__R9_E1a__driftTwo",
  "heroActions": "HeroSection-module-scss-module__R9_E1a__heroActions",
  "heroAvailability": "HeroSection-module-scss-module__R9_E1a__heroAvailability",
  "heroContent": "HeroSection-module-scss-module__R9_E1a__heroContent",
  "heroGrid": "HeroSection-module-scss-module__R9_E1a__heroGrid",
  "heroName": "HeroSection-module-scss-module__R9_E1a__heroName",
  "heroPortrait": "HeroSection-module-scss-module__R9_E1a__heroPortrait",
  "heroPortraitWrap": "HeroSection-module-scss-module__R9_E1a__heroPortraitWrap",
  "heroRole": "HeroSection-module-scss-module__R9_E1a__heroRole",
  "heroSection": "HeroSection-module-scss-module__R9_E1a__heroSection",
  "heroStats": "HeroSection-module-scss-module__R9_E1a__heroStats",
  "heroTagline": "HeroSection-module-scss-module__R9_E1a__heroTagline",
  "highlight": "HeroSection-module-scss-module__R9_E1a__highlight",
  "primaryCta": "HeroSection-module-scss-module__R9_E1a__primaryCta",
  "secondaryCta": "HeroSection-module-scss-module__R9_E1a__secondaryCta",
  "slideInLeft": "HeroSection-module-scss-module__R9_E1a__slideInLeft",
});
